export default __webpack_public_path__ + "static/media/star.e9e5d1d0.svg";